const groupByLocationCode = (marketingSources) => {
  return marketingSources.reduce(
    (acc, marketingSource) => {
      if (!acc[marketingSource.sLocationCode]) {
        acc[marketingSource.sLocationCode] = [];
      }
      acc[marketingSource.sLocationCode].push(marketingSource);
      return acc;
    },
    {}
  );
};
export {
  groupByLocationCode
};
//# sourceMappingURL=MarketingSource.mjs.map